














































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DepartmentDTO, ShipmentDTO } from "@/model/data.model";
import { elDatePickerFormat } from "@/services/Helpers";
import { Validations } from "vuelidate-property-decorators";
import { minLength, required } from "vuelidate/lib/validators";
import { isEmpty } from "lodash";
import { CustomerService } from "@/services/CustomerService";

@Component({})
export default class NewShipmentTopbar extends Vue {
  @Prop() shipment: ShipmentDTO;
  @Prop() edition: boolean;

  dateFormat: string;
  isDepartmentMandatory: boolean = this.$store.getters["customer/config"]
    .isDepartmentMandatory;
  onlySelectedDepartments: boolean = this.$store.getters["customer/config"]
    .onlySelectedDepartments;
  selectedDepartment: DepartmentDTO = null;

  @Validations()
  validations() {
    if (this.isDepartmentMandatory && this.edition) {
      return {
        selectedDepartment: { required },
        departments: { required, minLength: minLength(1) }
      };
    }
    return {};
  }

  set selectDepartment(department: DepartmentDTO) {
    this.selectedDepartment = department;
    this.$emit("departmentSelected", this.selectedDepartment);
  }

  get selectDepartment(): DepartmentDTO {
    return this.selectedDepartment;
  }

  get isInboundShipment() {
    return (
      this.$route.query.type === "inbound" &&
      this.$store.getters.features.inbound
    );
  }

  get departments() {
    return this.$store.getters["customer/departments"];
  }

  created() {
    this.dateFormat = elDatePickerFormat();
    let departmentAssigned = false;
    // Is user has a default department it has been already
    // assigned to this shipment in ShipmentDTO object creation
    // in NewShipment, so we just preselect it in the combo.
    if (
      this.shipment.customerDepartmentId !== undefined &&
      this.shipment.customerDepartmentId !== null &&
      this.shipment.customerDepartmentId !== 0
    ) {
      const filteredDepartments = this.departments.filter(
        (item: DepartmentDTO) => {
          return item.departmentId === this.shipment.customerDepartmentId;
        }
      );

      if (filteredDepartments.length > 0) {
        this.selectedDepartment = filteredDepartments[0];
        departmentAssigned = true;
      }
    }

    if (!departmentAssigned) {
      if (!this.isDepartmentMandatory) {
        this.selectedDepartment = this.departments[0];
      } else {
        if (this.departments.length === 1 && !this.onlySelectedDepartments) {
          this.selectedDepartment = this.departments[0];
          departmentAssigned = true;
        }
      }
    }
    if (!(this.shipment?.shipmentId !== "")) {
      //only trigger department change on created for new shipment
      // change on user action is managed with v-model="selectDepartment" above
      this.$emit("departmentSelected", this.selectedDepartment);
    }
  }

  selectCurrentDepartment() {
    this.$emit("departmentSelected", this.selectedDepartment);
  }

  handleDepartmentsClear(event: any) {
    if (isEmpty(event)) {
      CustomerService.loadCustomerDepartments(
        this.$store,
        this.$t("no_department").toString()
      );
    }
  }

  handleDepartmentsSearch(search: any) {
    this.selectedDepartment = search;

    if (search === undefined || search === "" || search.length < 3) {
      return;
    }

    const searchInput = search.toLowerCase();
    CustomerService.loadCustomerDepartments(
      this.$store,
      this.$t("no_department").toString(),
      0,
      searchInput
    );
  }
}
